import { Pattern } from '../../app/builder/contexts/PatternContext'
import { regeneratePatternIds } from './regeneratePatternIds'
import { migrateLegacyChangedConditions } from '../../app/builder/contexts/PatternTreeContext'

export async function copyPatternToAccount(
  sourcePattern: Pattern,
  forceSave: (pattern: Pattern) => Promise<Pattern | undefined>,
  originalGcid?: string
): Promise<Pattern | undefined> {
  const patternCopy: Pattern = JSON.parse(JSON.stringify(sourcePattern))

  patternCopy.original = {
    gcid: originalGcid || patternCopy.gcid || '',
    patternId: patternCopy.id || '',
    version: patternCopy.version || 1,
  }

  delete patternCopy.id
  delete patternCopy.version
  delete patternCopy.alertVersion

  regeneratePatternIds(patternCopy)

  // Apply legacy migration before saving so the Firestore version matches
  // what PatternTreeContext produces on load (making the re-migration a no-op)
  const migrated = migrateLegacyChangedConditions(patternCopy)

  return forceSave(migrated)
}
